export enum exsepProfile {
  underExamination = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED' ,
}
 